import { IManual, INewVerse } from '../utils/types'

const DB_NAME = 'nlwc_offline_db'
const DB_VERSION = 1
const BIBLE_STORE = 'bible_chapters'
const MANUALS_STORE = 'manuals'

let db: IDBDatabase | null = null

const openDB = (): Promise<IDBDatabase> => {
	return new Promise((resolve, reject) => {
		if (db) {
			resolve(db)
			return
		}
		const request = indexedDB.open(DB_NAME, DB_VERSION)

		request.onupgradeneeded = (event) => {
			const database = (event.target as IDBOpenDBRequest).result
			if (!database.objectStoreNames.contains(BIBLE_STORE)) {
				database.createObjectStore(BIBLE_STORE, { keyPath: 'key' })
			}
			if (!database.objectStoreNames.contains(MANUALS_STORE)) {
				database.createObjectStore(MANUALS_STORE, { keyPath: 'key' })
			}
		}

		request.onsuccess = (event) => {
			db = (event.target as IDBOpenDBRequest).result
			resolve(db)
		}

		request.onerror = () => reject(request.error)
	})
}

export const getCachedBibleChapter = async (bookId: string, chapterId: string): Promise<INewVerse[] | null> => {
	try {
		const database = await openDB()
		return new Promise((resolve) => {
			const tx = database.transaction(BIBLE_STORE, 'readonly')
			const store = tx.objectStore(BIBLE_STORE)
			const req = store.get(`${bookId}_${chapterId}`)
			req.onsuccess = () => resolve(req.result ? req.result.verses : null)
			req.onerror = () => resolve(null)
		})
	} catch {
		return null
	}
}

export const cacheBibleChapter = async (bookId: string, chapterId: string, verses: INewVerse[]): Promise<void> => {
	try {
		const database = await openDB()
		return new Promise((resolve) => {
			const tx = database.transaction(BIBLE_STORE, 'readwrite')
			const store = tx.objectStore(BIBLE_STORE)
			store.put({ key: `${bookId}_${chapterId}`, verses })
			tx.oncomplete = () => resolve()
			tx.onerror = () => resolve()
		})
	} catch {
		// silently fail — caching is best-effort
	}
}

export const getCachedManual = async (id: string): Promise<IManual | null> => {
	try {
		const database = await openDB()
		return new Promise((resolve) => {
			const tx = database.transaction(MANUALS_STORE, 'readonly')
			const store = tx.objectStore(MANUALS_STORE)
			const req = store.get(id)
			req.onsuccess = () => resolve(req.result ? req.result.data : null)
			req.onerror = () => resolve(null)
		})
	} catch {
		return null
	}
}

export const cacheManual = async (id: string, data: IManual): Promise<void> => {
	try {
		const database = await openDB()
		return new Promise((resolve) => {
			const tx = database.transaction(MANUALS_STORE, 'readwrite')
			const store = tx.objectStore(MANUALS_STORE)
			store.put({ key: id, data })
			tx.oncomplete = () => resolve()
			tx.onerror = () => resolve()
		})
	} catch {
		// silently fail — caching is best-effort
	}
}
